import styled from "styled-components";
import { theme } from "../../theme";

export const CircleActivityIndicator = styled.div<{
  color?: string;
  small?: boolean;
}>`
  width: ${(props) => (props.small ? "8px" : "16px")};
  height: ${(props) => (props.small ? "8px" : "16px")};
  border-radius: 50%;
  background-color: ${(props) => props.color ?? theme.colors.primary};
`;
